export enum PermanentListenerE {
    LISTEN_SERVICE_USAGE_UPDATE = 'LISTENER/SERVICE_USAGE_UPDATE',
    SET_QUICK_ACTION_LIB_MODE = 'LISTENER/SET_QUICK_ACTION_LIB_MODE',
    OPEN_CONFIRM_SHARE_DIALOG = 'LISTENER/OPEN_CONFIRM_SHARE_DIALOG',
    INSERT_QUICK_ACTION_RESULT = 'LISTENER/INSERT_QUICK_ACTION_RESULT',
    QG_STATE_CHANGED = 'QG_STATE_CHANGED',
}
